export const yiliao = {
    source: 'yiliao',
    quickActions: '当前工作',
    school: '企业',
    allSchool: '企业',
    elseSchool: '诊所',
    singleSchoole: '企业',
    subject: '企业',
    currentSchool: '就职企业',
    // staff: '员工',
    student: '学员',
    // elseStudent: '成员',
    lecturer: '讲师',
    teacher: '主讲',
    mainTeacher: '讲师',
    assistantTeacher: '助教老师',
    class: '班级',
    singleClass: '班',
    allClass: '全班',
    newStudents: '招生',
    clue: '线索',
    sale: '管理员',
    subjectManage: '管理员',
    headmaster: '董事长',
    textbook: '素材',
    shopAuth: '管理员',
    wechatAuth: '学员',
    msgSend:'“智能企培”公众号的学员',
    sjManage: '管理员',
    mainCampus: '企业',
    joinCampus: '企业',
    subject2: '岗位',
    subjectManageTitle: '企培岗位',
    function:"独立手机官网、独立营销体系",
    activity:"优惠活动",
  }

  export default yiliao
